import React, { useState } from 'react';

function Header({ setCurrentPage, darkMode, toggleDarkMode }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavClick = (page) => {
    setCurrentPage(page);
    setMenuOpen(false); // Close menu after clicking
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <h1 onClick={() => handleNavClick('home')} style={{ cursor: 'pointer' }}>💊 Disha Medical Store</h1>
        </div>

        {/* Hamburger Menu Button */}
        <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Navigation */}
        <nav className={`nav ${menuOpen ? 'active' : ''}`}>
          <button onClick={() => handleNavClick('home')}>Home</button>
          <button onClick={() => handleNavClick('products')}>Products</button>
          <button onClick={() => handleNavClick('about')}>About Us</button>
          <button onClick={() => handleNavClick('cart')}>Cart</button>
          <button className="dark-mode-toggle" onClick={toggleDarkMode} title="Toggle Dark Mode">
            {darkMode ? '☀️' : '🌙'}
          </button>
        </nav>
      </div>
    </header>
  );
}

export default Header;